export const RecoveryPhasePath = 'recovery-path';
/** 1 minute */
export const AUTOMATIC_TOKEN_CHECK_TIME_MS = 60000;
